import React, { useMemo } from 'react';

import css from './NutrientSummary.module.css';

const NutrientSummary = ({ menuDishes }) => {

    const summary = useMemo(() => {
        if (!menuDishes?.length) return null;

        const totals = menuDishes.reduce((acc, menuDish) => {
            const dish = menuDish.dish;
            if (!dish) return acc;

            let calories = Number(dish.energy) || 0;
            let proteins = Number(dish.proteins) || 0;
            let fats = Number(dish.fats) || 0;
            let carbs = Number(dish.carbs) || 0;

            if (menuDish.proteinDish) {
                calories += Number(menuDish.proteinDish.energy) || 0;
                proteins += Number(menuDish.proteinDish.proteins) || 0;
                fats += Number(menuDish.proteinDish.fats) || 0;
                carbs += Number(menuDish.proteinDish.carbs) || 0;
            }

            if (menuDish.sauceDish) {
                calories += Number(menuDish.sauceDish.energy) || 0;
                proteins += Number(menuDish.sauceDish.proteins) || 0;
                fats += Number(menuDish.sauceDish.fats) || 0;
                carbs += Number(menuDish.sauceDish.carbs) || 0;
            }

            return {
                calories: acc.calories + calories,
                proteins: acc.proteins + proteins,
                fats: acc.fats + fats,
                carbs: acc.carbs + carbs
            };
        }, { calories: 0, proteins: 0, fats: 0, carbs: 0 });

        // Calculate percentages (avoid division by zero)
        const getPercentage = (macroCalories) => {
            if (totals.calories === 0) return 0;
            return Math.round((macroCalories / totals.calories) * 100);
        };

        // Calculate calories from each macronutrient for percentage calculation
        const proteinCalories = totals.proteins * 4;
        const fatCalories = totals.fats * 9;
        const carbCalories = totals.carbs * 4;

        return {
            ...totals,
            proteinPercentage: getPercentage(proteinCalories),
            fatPercentage: getPercentage(fatCalories),
            carbPercentage: getPercentage(carbCalories)
        };
    }, [menuDishes]);

    if (!summary) return null;

    return (
        <div className={css.summary}>
            <div className={css.nutrient}>
                <span className={css.value}>{Math.round(summary.calories)}</span>
                <span className={css.label}>kcal</span>
            </div>
            <div className={css.nutrient}>
                <span className={css.value}>{Math.round(summary.proteins)}g</span>
                <span className={css.label}>P {summary.proteinPercentage}%</span>
            </div>
            <div className={css.nutrient}>
                <span className={css.value}>{Math.round(summary.fats)}g</span>
                <span className={css.label}>F {summary.fatPercentage}%</span>
            </div>
            <div className={css.nutrient}>
                <span className={css.value}>{Math.round(summary.carbs)}g</span>
                <span className={css.label}>C {summary.carbPercentage}%</span>
            </div>
        </div>
    );
};

export default React.memo(NutrientSummary); 